import React from "react";
import { IDialogProviderContext } from "./types";

// @ts-ignore
export default React.createContext<IDialogProviderContext>();
